"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Calendar.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Calendar = function Calendar(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 174.93 174.93"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Calendar Icon"), _react2.default.createElement("g", {
    className: "calendar",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M160.36 16.35h-23.7V5.48a5.475 5.475 0 0 0-10.95 0v10.87H92.96V5.48a5.475 5.475 0 0 0-10.95 0v10.87H49.19V5.48a5.46 5.46 0 1 0-10.91 0v10.87h-23.7A14.59 14.59 0 0 0-.04 30.96v129.39a14.6 14.6 0 0 0 14.57 14.6h145.83a14.6 14.6 0 0 0 14.6-14.6V30.96a14.59 14.59 0 0 0-14.6-14.61zm3.6 144a3.64 3.64 0 0 1-3.63 3.66H14.58a3.64 3.64 0 0 1-3.62-3.66V30.96a3.63 3.63 0 0 1 3.62-3.61h23.7v10.93a5.46 5.46 0 0 0 10.91 0V27.35h32.77v10.93a5.475 5.475 0 0 0 10.95 0V27.35h32.77v10.93a5.475 5.475 0 0 0 10.95 0V27.35h23.7a3.63 3.63 0 0 1 3.63 3.61v129.39z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M38.28 65.61h21.86V82H38.28zm0 27.33h21.86v16.39H38.28zm0 27.33h21.86v16.39H38.28zm38.24 0h21.86v16.39H76.52zm0-27.33h21.86v16.39H76.52zm0-27.33h21.86V82H76.52zm38.27 54.66h21.86v16.39h-21.86zm0-27.33h21.86v16.39h-21.86zm0-27.33h21.86V82h-21.86z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  })));
};
exports.default = Calendar;